import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import { App } from './App';
import './styles.css';
import { DialogHost } from './components/Dialogs';

const container = document.getElementById('root');

if (container === null) {
  throw new Error('No #root element. Check index.html.');
}

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
        <DialogHost />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
